import Box from '@repo/ui/box'
import { useQuery } from '@tanstack/react-query'

import { getMission } from '../../../../api/missions/get-mission'
import { MissionTypeEnum } from '../../../../lib/types/enums/mission/mission-type.enum'
import LoadingScreen from '../../../elements/loading/loading-screen'
import AffectedExternalStaffList from './affected-external-staff-list'
import AffectedLecStaffList from './affected-lec-staff-list'
import AffectedStaffList from './affected-staff-list'

export type MissionStaff = {
  missionId: number
  mode: 'view' | 'edit'
}

export type MissionModalType = 'add-staff' | 'add-external-staff' | 'add-lec-staff'

const MissionStaffTable = ({ missionId, mode = 'edit' }: MissionStaff) => {
  const { data: mission, isLoading } = useQuery({
    queryKey: ['missions', missionId],
    queryFn: () => getMission(missionId)
  })

  if (!mission || isLoading) return <LoadingScreen />

  return (
    <Box className="rounded-lg">
      {mission.type === MissionTypeEnum.STAFF && (
        <AffectedStaffList missionId={missionId} mode={mode} />
      )}
      {mission.type === MissionTypeEnum.EXTERNAL && (
        <AffectedExternalStaffList missionId={missionId} mode={mode} />
      )}
      {mission.type === MissionTypeEnum.OFFICE && (
        <AffectedLecStaffList missionId={missionId} mode={mode} />
      )}
    </Box>
  )
}

export default MissionStaffTable
